import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';

export const useIsAdmin = () => {
  const { user, isAdmin: isTokenAdmin, loading: authLoading } = useAuth();

  const { data: isDbAdmin = false, isLoading: dbLoading } = useQuery({
    queryKey: ['isAdmin', user?.id],
    queryFn: async () => {
      if (!user) return false;
      const { data, error } = await supabase.rpc('has_role', { 
        _user_id: user.id, 
        _role: 'admin' 
      });
      if (error) {
        console.error('Error checking admin role:', error);
        return false;
      }
      return !!data;
    },
    // Only run query if we don't already know they are admin from the token
    enabled: !!user && !isTokenAdmin,
    staleTime: 1000 * 60 * 30, // Cache admin status for 30 mins (admin status rarely changes mid-session)
    gcTime: 1000 * 60 * 60,    // Keep in memory for 1 hour to survive tab switches
  });

  // Fast-path: if JWT already says admin, skip ALL loading states
  const loading = isTokenAdmin ? false : (authLoading || dbLoading);
  const isAdmin = isTokenAdmin || isDbAdmin;

  return { isAdmin, loading };
};
